import { render, staticRenderFns } from "./elastic.vue?vue&type=template&id=3fae50a6&"
import script from "./elastic.vue?vue&type=script&lang=js&"
export * from "./elastic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports